import React from 'react';

const Analytics = ({ width = 16, height = 16, className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M10.75 8.75L13 6"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M7.25 6.75L9.25 8.75"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3 10L5.75 6.75"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.5 6C14.0523 6 14.5 5.55228 14.5 5C14.5 4.44772 14.0523 4 13.5 4C12.9477 4 12.5 4.44772 12.5 5C12.5 5.55228 12.9477 6 13.5 6Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M2.5 12C3.05228 12 3.5 11.5523 3.5 11C3.5 10.4477 3.05228 10 2.5 10C1.94772 10 1.5 10.4477 1.5 11C1.5 11.5523 1.94772 12 2.5 12Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default Analytics;
